import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _Errors;

// Constants
var Errors = (_Errors = {
  'cb5501': {
    'category': 'location',
    'display': 'inplace',
    'type': 'error',
    'title': 'We\'re not able to find your location',
    'body': 'Please re-enter the location details again or try a different address.'
  },
  'cb5502': {
    'category': 'location',
    'display': 'toast',
    'type': 'error',
    'options': {
      'autohide': false,
      'delay': '5000'
    },
    'title': 'Location error',
    'body': 'We had some issues trying to pinpoint your location.'
  },
  'cb6001': {
    'category': 'waitlist',
    'display': 'toast',
    'type': 'info',
    'options': {
      'autohide': true,
      'delay': '6000'
    },
    'title': 'Wait List cancellation',
    'body': 'Your Wait List entry has been cancelled successfully.'
  },
  'cb6501': {
    'category': 'waitlist',
    'display': 'inplace',
    'type': 'error',
    'title': 'Wait List error',
    'body': 'There was a problem adding you to the Wait List. Please try again.'
  },
  'cb7501': {
    'category': 'olo',
    'display': 'modal',
    'type': 'error',
    'title': 'Order Error',
    'body': 'We hit an unexpected error - code: cb7501 - Please try again'
  },
  'cb7502': {
    'category': 'olo',
    'display': 'modal',
    'type': 'error',
    'title': 'Order Error',
    'body': 'Your selected store does not deliver to the selected delivery address.'
  }
}, _defineProperty(_Errors, "cb7502", {
  'category': 'olo',
  'display': 'toast',
  'type': 'error',
  'title': 'Detail Error',
  'body': 'There was a problem aquiring detail information.'
}), _defineProperty(_Errors, 'cb7503', {
  'category': 'olo',
  'display': 'modal',
  'type': 'error',
  'title': 'We aren\'t able to deliver right now',
  'body': 'We apologize, you\'re outside of our delivery radius and we can\'t deliver to you right now.'
}), _defineProperty(_Errors, 'cb7504', {
  'category': 'olo',
  'display': 'modal',
  'type': 'error',
  'title': 'Order Error',
  'body': 'This item is no longer available'
}), _defineProperty(_Errors, 'cb7505', {
  'category': 'olo',
  'display': 'modal',
  'type': 'error',
  'title': 'Order Error',
  'body': 'There was a problem with your order.'
}), _defineProperty(_Errors, 'cb7506', {
  'category': 'olo',
  'display': 'modal',
  'type': 'error',
  'title': 'We aren\'t able to deliver right now',
  'body': 'We apologize, delivery is not available right now. Please try again later or select a different time'
}), _defineProperty(_Errors, 'cb7507', {
  'category': 'olo',
  'display': 'internal',
  'type': 'error',
  'title': 'Billing Scheme Error',
  'body': 'We are unable to get billing schemes as this time'
}), _defineProperty(_Errors, 'cb7508', {
  'category': 'olo',
  'display': 'internal',
  'type': 'error',
  'title': 'Generic Error',
  'body': 'Generic Internal Error'
}), _defineProperty(_Errors, 'cb7601', {
  'category': 'shop',
  'display': 'modal',
  'type': 'error',
  'title': 'Mixed Cart',
  'body': 'We currently don’t support combining a retail order and a food order, please remove all items in one or the other cart'
}), _defineProperty(_Errors, 'cb7602', {
  'category': 'shop',
  'display': 'inplace',
  'type': 'error',
  'title': 'Gift card',
  'body': 'Gift card already added.'
}), _defineProperty(_Errors, 'cb7603', {
  'category': 'shop',
  'display': 'inplace',
  'type': 'error',
  'title': 'Gift card',
  'body': 'Gift card balance cannot be retrieved.'
}), _defineProperty(_Errors, 'cb8501', {
  'category': 'account',
  'display': 'internal',
  'type': 'error',
  'title': 'Account delete error',
  'body': 'Account id not found'
}), _defineProperty(_Errors, 'cb8502', {
  'category': 'account',
  'display': 'toast',
  'type': 'error',
  'title': 'Order Status Error',
  'body': 'An unexpected error occured. Please try again later'
}), _defineProperty(_Errors, 'cb8503', {
  'category': 'account',
  'display': 'modal',
  'type': 'error',
  'title': '',
  'body': 'You’ve got great taste, unfortunately item is not available right now'
}), _defineProperty(_Errors, 'cb9999', {
  'category': 'cart',
  'display': 'modal',
  'type': 'error',
  'title': 'Order Error',
  'body': 'Please select a valid time'
}), _defineProperty(_Errors, 'mobilepay-notfound', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': 'Hmmm, we can’t find a receipt with that code. Please try again'
}), _defineProperty(_Errors, 'mobilepay-generic', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': 'Something went wrong'
}), _defineProperty(_Errors, 'mobilepay-ls-timeout', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': 'Timed Out'
}), _defineProperty(_Errors, 'mobilepay-ls-success', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'success',
  'title': 'Success',
  'body': 'Transaction Complete'
}), _defineProperty(_Errors, 'mobilepay-ls-notfound', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': 'Order Not Found'
}), _defineProperty(_Errors, 'mobilepay-wp-826', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "We're having trouble processing your payment. Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-870', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Success',
  'body': "Success"
}), _defineProperty(_Errors, 'mobilepay-wp-871', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "Something's not right... Please check your card number and try again"
}), _defineProperty(_Errors, 'mobilepay-wp-872', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "Something's not right... Please check your card number and try again"
}), _defineProperty(_Errors, 'mobilepay-wp-873', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "Something's not right... Please check your card number and try again"
}), _defineProperty(_Errors, 'mobilepay-wp-874', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "Something's not right... Please check your card number and try again"
}), _defineProperty(_Errors, 'mobilepay-wp-875', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-876', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "Something's not right... Please check your card number and try again"
}), _defineProperty(_Errors, 'mobilepay-wp-881', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-882', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-883', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-884', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-885', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-889', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "It's not you, it's us... Please try again."
}), _defineProperty(_Errors, 'mobilepay-wp-noexpirationvalue', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "You must provide an expiration date"
}), _defineProperty(_Errors, 'mobilepay-wp-invalidExp', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "You must provide an valid expiration date"
}), _defineProperty(_Errors, 'mobilepay-disabled', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "Please pay at the register."
}), _defineProperty(_Errors, 'mobilepay-nopayment', {
  'category': 'mobilepay',
  'display': 'modal',
  'type': 'error',
  'title': 'Error',
  'body': "You must add an valid payment first."
}), _defineProperty(_Errors, 'default', {
  'display': 'internal',
  'title': 'Unexpected error',
  'body': 'An unexpected error occured. Please try again later.'
}), _Errors);
export default Errors;